/**
 * @file ApiTest
 */

'use strict';

/**
 * @classname ApiTest
 * @classdesc ApiTest
 */
export default class ApiTest {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e, controller) {
		console.log(`ApiTest.constructor`);
		this._$e = $e;
		this._controller = controller;
		this._$e.on('change', () => this.onChange());
		this._controller.on('apiTestComplete', () => this.onApiTestComplete());
	}


	/**
	 * 'change' のコールバック
	 *
	 * @memberof ApiTest
	 * @return {undefined}
	 */
	onChange() {
		console.log(`ApiTest.onChange`);
		const val = this._$e.val();
		if (val && val !== '') {
			this._controller.apiTest(val);
		}
	}


	/**
	 * 
	 *
	 * @memberof ApiTest
	 * @return {undefined}
	 */
	checkDispatchNecessity() {
		if (this._inModal) {
			return (this._$e.val() === '' && this._$e.closest('.modal').find('.council_id').val())
		} else if (this._inTable) {
			return (this._$e.val() === '' && this._$e.closest('.table').find('.council_id').val())
		} else {
			return (this._$e.val() === '' && this._$e.closest('form').find('.council_id').val())
		}
	}


	/**
	 * 団リスト取得完了コールバック
	 *
	 * @memberof ApiTest
	 * @return {undefined}
	 */
	onGetGroupsComplete() {
		if(!this._changed) return;
		console.log(`ApiTest.onGetGroupsComplete`);
		console.log(this._controller._groups);
		if(this._inTable) {
			this._$e.closest('.tr').find('.group_id').html(this.createOptions(this._controller._groups));
			this._$e.closest('.tr').find('.affiliation_id').html('<option value="">--</option>');
			this._$e.closest('.tr').find('.title_id').html('<option value="">--</option>');
		} else if (this._inModal) {
			this._$e.closest('.modal').find('.group_id').html(this.createOptions(this._controller._groups));
			this._$e.closest('.modal').find('.affiliation_id').html('<option value="">--</option>');
			this._$e.closest('.modal').find('.title_id').html('<option value="">--</option>');
		} else {
			$('.group_id').html(this.createOptions(this._controller._groups));
			$('.affiliation_id').html('<option value="">--</option>');
			$('.title_id').html('<option value="">--</option>');
		}
		this._changed = false;
	}


	/**
	 * 団リスト・所属リスト取得完了コールバック
	 *
	 * @memberof ApiTest
	 * @return {undefined}
	 */
	onGetGroupsAffiliationsComplete() {
		if(!this._changed) return;
		console.log(`ApiTest.onGetGroupsAffiliationsComplete`);
		console.log(this._controller._groups);
		console.log(this._controller._affiliations);
		if(this._inTable) {
			this._$e.closest('.tr').find('.group_id').html(this.createOptions(this._controller._groups));
			this._$e.closest('.tr').find('.affiliation_id').html(this.createOptions(this._controller._affiliations));
			this._$e.closest('.tr').find('.title_id').html('<option value="">--</option>');
		} else if (this._inModal) {
			this._$e.closest('.modal').find('.group_id').html(this.createOptions(this._controller._groups));
			this._$e.closest('.modal').find('.affiliation_id').html(this.createOptions(this._controller._affiliations));
			this._$e.closest('.modal').find('.title_id').html('<option value="">--</option>');
		}else{
			$('.group_id').html(this.createOptions(this._controller._groups));
			$('.affiliation_id').html(this.createOptions(this._controller._affiliations));
			$('.title_id').html('<option value="">--</option>');
		}
		this._changed = false;
	}


	/**
	 * option生成
	 *
	 * @memberof ApiTest
	 * @return {undefined}
	 */
	createOptions(items) {
		console.log(`ApiTest.createOptions`);
		let options = '<option value="">▼選択</option>';
		items.forEach(item => options += `<option value='${item.id}'>${item.name}</option>`);
		return options
	}
}
